<div class="modal-header">
    <h4>{{header}}</h4>
</div>
<div class="modal-body">
    <div class="card row" style="display: block; margin-left: 0px; margin-bottom: 10px;">
        <span style="font-weight: bold;">{{body}}</span>
    </div>

    <div class="card row" style="display:block;margin-left: 0px;color:red;" *ngIf="offlinePostFailList?.length > 0">
        Error: {{offlinePostFailList.length}} items failed to sync.
        <ul>
            <li *ngFor="let data of offlinePostFailList">
                {{data.url.substr(data.url.indexOf("/SM/"))}}
                <ul>
                    <li>{{data.result.error}}</li>
                </ul>
            </li>
        </ul>
    </div>

    <div class="card row" style="display:block;margin-left: 0px;font-weight: bold;" *ngIf="offlinePostFailList?.length > 0">
        If you would like to delete the lines that are failing to sync, choose Delete.
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" *ngIf="offlinePostFailList?.length > 0" (click)="deleteClicked()">Delete </button>

    <button type="button" class="btn btn-primary" (click)="confirmClicked()" style="float: right;">Sync</button>
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()" style="float: right;">Cancel</button>
</div>